import React from "react";
import { AiFillCode, AiFillHome, AiOutlineGithub } from "react-icons/ai";
import PersonIcon from "@mui/icons-material/Person";

const menuConfig = {
  sidebarData: [
    {
      id: "menu-0",
      title: "Home",
      title_i18n: { en: "Home", es: "Inicio" },
      path: "/",
      icon: <AiFillHome size={35} />,
      className: "nav-text",
    },
    {
      id: "menu-1",
      title: "Projects",
      title_i18n: { en: "Projects", es: "Proyectos" },
      path: "/projects",
      icon: <AiOutlineGithub size={35} />,
      className: "nav-text",
    },
    // {
    //   id: "menu-2",
    //   title: "Blogs",
    //   title_i18n: { en: "Blogs", es: "Blog" },
    //   path: "/blogs",
    //   icon: <BsMedium size={35} />,
    //   className: "nav-text",
    // },
    {
      id: "menu-3",
      title: "Skills",
      title_i18n: { en: "Skills", es: "Habilidades" },
      path: "/skills",
      icon: <AiFillCode size={35} />,
      className: "nav-text",
    },
    {
      id: "menu-4",
      title: "About",
      title_i18n: { en: "About", es: "Sobre mí" },
      path: "/about",
      icon: <PersonIcon sx={{ fontSize: 35 }} />,
      className: "nav-text",
    },
  ],
};

export default menuConfig;
